export default __webpack_public_path__ + "static/media/Grises_logo.fbc1fb5d.png";